import {
  MENSAJE_TIPO_PREGUNTA,
  MENSAJE_TIPO_RESPUESTA,
  MENSAJE_TIPO_COMPRA_A,
  MENSAJE_TIPO_COMPRA_B,
  MENSAJE_TIPO_PRESUPUESTO,
  MENSAJE_TIPO_MONTOS_A,
  MENSAJE_TIPO_MONTOS_B,
  MENSAJE_TIPO_PUBLICACION_VENCIDA,
  MENSAJE_TIPO_CARGA_MASIVA,
  MENSAJE_TIPO_PEDIDO_COMPRA,
  MENSAJE_TIPO_PEDIDO_VENTA,
  MENSAJE_TIPO_TIENDA_OFICIAL,
  MENSAJE_TIPO_DEVOLUCION,
  MENSAJE_TIPO_CANCELACION
} from '../../constants/mensajesTipos.js'

export const CATEGORIA_PREGUNTA = {
  id: 'PREGUNTA',
  etiqueta: 'Pregunta',
  icono: 'fa-question-circle',
  clase: 'tag_pregunta'
}
export const CATEGORIA_RESPUESTA = {
  id: 'RESPUESTA',
  etiqueta: 'Respuesta',
  icono: 'fa-reply',
  clase: 'tag_respuesta'
}
export const CATEGORIA_COMPRA = {
  id: 'COMPRA',
  etiqueta: 'Compra',
  icono: 'fa-shopping-cart',
  clase: 'tag_compra'
}
export const CATEGORIA_VENTA = {
  id: 'VENTA',
  etiqueta: 'Venta',
  icono: 'fa-shopping-bag',
  clase: 'tag_venta'
}
export const CATEGORIA_DEVOLUCION = {
  id: 'DEVOLUCION',
  etiqueta: 'Devolución',
  icono: 'fa-undo',
  clase: 'tag_devolucion'
}
export const CATEGORIA_CANCELACION = {
  id: 'CANCELACION',
  etiqueta: 'Cancelación',
  icono: 'fa-times',
  clase: 'tag_cancelacion'
}
export const CATEGORIA_PRESUPUESTO = {
  id: 'PRESUPUESTO',
  etiqueta: 'Presupuesto',
  icono: 'fa-file-text-o',
  clase: 'tag_presupuesto'
}
export const CATEGORIA_MONTOS = {
  id: 'MONTOS',
  etiqueta: 'Impuestos y envíos',
  icono: 'fa fa-usd',
  clase: 'tag_montos'
}
export const CATEGORIA_VENCIMIENTO = {
  id: 'VENCIMIENTO',
  etiqueta: 'Vencimiento',
  icono: 'fa-exclamation-triangle',
  clase: 'tag_vencimiento'
}
export const CATEGORIA_TIENDA = {
  id: 'TIENDA',
  etiqueta: 'Tienda oficial',
  icono: 'fa-building',
  clase: 'tag_tienda'
}
export const CATEGORIA_CARGA_MASIVA = {
  id: 'CARGA_MASIVA',
  etiqueta: 'Carga masiva',
  icono: 'fa-cloud-upload',
  clase: 'tag_carga'
}
export const CATEGORIA_GENERAL = {
  id: 'GENERAL',
  etiqueta: 'Notificación',
  icono: 'fa-bell',
  clase: 'tag_general'
}

export const obtenerCategoria = (notificacion, idUsuario) => {
  const esVendedor = notificacion.idVendedor === idUsuario
  const esComprador = notificacion.idComprador === idUsuario
  const categoriaPedido = esComprador && !esVendedor ? CATEGORIA_COMPRA : CATEGORIA_VENTA

  switch (notificacion.idMensajeTipo) {
    case MENSAJE_TIPO_PREGUNTA:
    case MENSAJE_TIPO_RESPUESTA:
      return esVendedor ? CATEGORIA_PREGUNTA : CATEGORIA_RESPUESTA
    case MENSAJE_TIPO_COMPRA_A:
    case MENSAJE_TIPO_COMPRA_B:
      return categoriaPedido
    case MENSAJE_TIPO_PRESUPUESTO:
      return CATEGORIA_PRESUPUESTO
    case MENSAJE_TIPO_MONTOS_A:
    case MENSAJE_TIPO_MONTOS_B:
      return CATEGORIA_MONTOS
    case MENSAJE_TIPO_PUBLICACION_VENCIDA:
      return CATEGORIA_VENCIMIENTO
    case MENSAJE_TIPO_CARGA_MASIVA:
      return CATEGORIA_CARGA_MASIVA
    case MENSAJE_TIPO_PEDIDO_COMPRA:
    case MENSAJE_TIPO_PEDIDO_VENTA:
      return categoriaPedido
    case MENSAJE_TIPO_TIENDA_OFICIAL:
      return CATEGORIA_TIENDA
    case MENSAJE_TIPO_DEVOLUCION:
      return CATEGORIA_DEVOLUCION
    case MENSAJE_TIPO_CANCELACION:
      return CATEGORIA_CANCELACION
    default:
      break
  }

  switch (notificacion.tipoNotificacion) {
    case 'PUBLICACION':
      return esVendedor ? CATEGORIA_PREGUNTA : CATEGORIA_RESPUESTA
    case 'COMPRAS':
      return categoriaPedido
    case 'PEDIDO_CABECERA':
      return categoriaPedido
    case 'PRESUPUESTO':
      return CATEGORIA_PRESUPUESTO
    case 'PUBLICACION_VENCIDA':
      return CATEGORIA_VENCIMIENTO
    case 'TIENDA_OFICIAL':
      return CATEGORIA_TIENDA
    default:
      return CATEGORIA_GENERAL
  }
}
